export interface LayerConfigurator {
  tabName: string;
  visibility: string[];
  content: TabContent[];
}

export interface TabContent {
  groupName: string;
  type: string;
  values: string[];
  labels: string[];
  legend?: string[];
  checked: any;
  enabledBy?: string[];
  enableOperator?: string;
}

export interface ActiveLayers {
  tabName: string;
  groupName: string;
  layerId: string;
  layerName: string;
  visibility: boolean;
  disabled: boolean; // based on zoom level
}
